module.exports = __webpack_public_path__ + "img/TvDip/TvDip-favicon-32x32.png";